/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/styles/settings.scss'

// Composables
import { createVuetify } from 'vuetify'
import {
  VDataTable,
} from "vuetify/labs/VDataTable";

const okasoLightTheme = {
  dark: false,
  colors: {
    background: '#FDF9E4',
    black: '#000000',
    white: '#ffffff',
    gray: '#D7D7D7',
    'green-01': '#41A781',
    'green-02': '#9BD750',
    'green-03': '#E9F9CC',
    pink: '#F85891',
    red:'#DF0000',
    water: '#55C0ED',
    blue: '#42A5F5',
    'blue-01': '#E3F2FD',
  },
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'okasoLightTheme',
    themes: {
      okasoLightTheme,
    },
  },
  components: {
    VDataTable,
  },
})
